module.exports = __webpack_public_path__ + "static/media/quinzaine.93f52be1.svg";